// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"a629a2f7","283":"42b00bbe","447":"ce02bc62","506":"7094963a"}[chunkId] + ".chunk.js";
};